export default __webpack_public_path__ + "static/media/MAPLE.b7bcda1c.png";